"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = exports.TEST_ID_SELECT = void 0;
var react_1 = __importDefault(require("react"));
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var down_arrow_svg_1 = __importDefault(require("./down-arrow.svg"));
exports.TEST_ID_SELECT = "select";
var Select = function (_a) {
    var children = _a.children, csx = _a.csx, name = _a.name, currentValue = _a.currentValue, onChange = _a.onChange, restProps = __rest(_a, ["children", "csx", "name", "currentValue", "onChange"]);
    return (react_1.default.createElement(theme_ui_1.Select, __assign({ name: name, sx: __assign({ background: "url(" + down_arrow_svg_1.default + ") no-repeat right " + theme_1.theme.space[2] + "px center", "+ svg": {
                display: "none"
            } }, csx), "data-testid": exports.TEST_ID_SELECT, defaultValue: currentValue, onChange: onChange }, restProps), children));
};
exports.Select = Select;
